/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SocialEmail.vue?vue&type=template&id=25d19971&"
import script from "./SocialEmail.vue?vue&type=script&lang=js&"
export * from "./SocialEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports